import { render, staticRenderFns } from "./quickCreateQues.vue?vue&type=template&id=7453a980"
import script from "./quickCreateQues.vue?vue&type=script&lang=js"
export * from "./quickCreateQues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports